import { Component, PropsWithChildren } from 'react'

interface ClfOversellWarningErrorBoundaryProps {
  onError: () => void
}

interface ClfOversellWarningErrorBoundaryState {
  hasError: boolean
}

export class ClfOversellWarningErrorBoundary extends Component<
  PropsWithChildren<ClfOversellWarningErrorBoundaryProps>,
  ClfOversellWarningErrorBoundaryState
> {
  public static getDerivedStateFromError() {
    return { hasError: true }
  }

  public state = { hasError: false }

  public componentDidCatch() {
    this.props.onError()
  }

  public render() {
    return this.state.hasError ? null : this.props.children
  }
}
